import React from 'react';
import { FileText } from 'lucide-react';
import { motion } from 'framer-motion';

const QuickQuoteButton = ({ onClick }) => {
  return (
    <motion.button
      onClick={onClick}
      className="fixed bottom-24 right-6 z-40 group"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: 'spring' }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="relative">
        {/* Pulsing ring */}
        <div className="absolute inset-0 bg-amber-500 rounded-full animate-ping opacity-75"></div>
        
        {/* Main button */}
        <div className="relative flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 rounded-full shadow-2xl transition-all duration-300">
          <FileText className="w-8 h-8 text-white" />
        </div>
        
        {/* Tooltip */}
        <div className="absolute right-20 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <div className="bg-slate-900 text-white px-4 py-2 rounded-lg shadow-xl whitespace-nowrap text-sm font-medium">
            Quick Quote Request
            <div className="absolute right-0 top-1/2 transform translate-x-2 -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-slate-900"></div>
          </div>
        </div>
      </div>
    </motion.button>
  );
};

export default QuickQuoteButton;